import Container from '@material-ui/core/Container'
import React, {useState} from 'react'
import {Button, CircularProgress, Typography} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import {Autocomplete, TextField as MUITextField} from "@mui/material";
import {connect} from "react-redux";
import {getAllArbitrators, getAllMemoAssignments, getMemoAssignableTeams} from "../../../reducers/adminSelectors";
import {getCurrentMoot} from "../../../reducers/mootSelectors";
import {saveArbitratorPairing} from "../../../actions/adminActions"
import {filter, find, noop, size} from "lodash/fp";
import Grid from "@material-ui/core/Grid";
import {NavLink, useHistory} from "react-router-dom";
import {TEAM_ROLE_TYPE} from "../../../utils/constants";
import {mapWithIndex} from "../../../utils/funcUtils";

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
    },
}))

const AddAssignment = ({router,
                           assignableClaimantArbitrators,
                           assignableRespondentArbitrators,
                           memoAssignableTeams,
                           getCurrentMoot,
                           currentMoot,
                           getAllArbitrators = noop,
                           getMemoAssignableTeams = noop,
                           saveArbitratorPairing = noop,
                           getAllMemoAssignments = noop}) => {

    const classes = useStyles()
    const [selectedArbitratorId, setSelectedArbitratorId] = useState()
    const [selectedTeams, setSelectedTeams] = useState([])
    const [isFetching, setIsFetching] = useState(false)
    const [memoAssignmentCount,setMemoAssignmentCount] = useState(0)
    const history = useHistory()

    const role = router.location.query.role


    const TeamAssignment = ({value, changeHandler}) => {
        return (
            <Autocomplete
                options={getTeamsAssignableForThisRole(memoAssignableTeams)}
                getOptionLabel={value => find(t => value.id ? value.id === t.id : value === t.id, memoAssignableTeams)?.school}
                isOptionEqualToValue={(option, value) => option.id === value}
                value={value}
                autoSelect
                onChange={(e, newValue) => {
                    if (newValue) {
                        changeHandler(newValue.id)
                    }
                }}
                renderInput={(params) => <MUITextField {...params} variant="standard" label="School"
                                                       required/>}
            />
        )
    }
    const getTeamsAssignableForThisRole = teams => {
        return filter(t => {
            return find (d => d.documentType === role,t.TeamDocuments)
        },teams)
    }

    React.useEffect(() => {
        const asyncFetchData = async () => {
            try {
                setIsFetching(true)
                const moot = await getCurrentMoot()
                await getAllArbitrators()
                const teams = await getMemoAssignableTeams()
                const assignableTeams = getTeamsAssignableForThisRole(teams)

                let assignmentCount = role === 'RESPONDENT' ? moot.ArbitratorRespondentMemoRankingCount
                    : moot.ArbitratorClaimantMemoRankingCount
                setMemoAssignmentCount(assignmentCount)

                if (size(assignableTeams) >= assignmentCount) {
                    const temp = []
                    for(let i = 0; i < assignmentCount; i++) {
                        temp.push(assignableTeams[i]?.id)
                    }
                    setSelectedTeams(temp)
                }

                setIsFetching(false)
            } catch (e) {
                //TODO ?
            }
        }
        asyncFetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onSave = async e => {
        e.preventDefault()
        try {
            setIsFetching(true)
            const result = await saveArbitratorPairing({
                arbitratorId: selectedArbitratorId,
                teams: selectedTeams,
                role: role
            })
            if (result) {
                await getAllMemoAssignments(role,true)
                history.replace(`/admin/memoAssignments?role=${role}`)
            }
        }finally {
            setIsFetching(false)
        }

    }

    const onTeamSelected = (teamId,index) =>
        setSelectedTeams(mapWithIndex((item,idx) => {
                if (idx === index) {
                    return teamId
                } else {
                    return selectedTeams[idx]
                }
            }
    ,selectedTeams))

    return (
        <Container maxWidth='xl' className={classes.root}>
            <Typography variant='h4' style={{textTransform: 'capitalize'}}>Add Arbitrator Evaluator for {role?.toLowerCase()} Memos</Typography>
            {isFetching &&
                <CircularProgress/>
            }
            {!isFetching &&
                <form onSubmit={onSave}>
                    <Grid container style={{flexGrow: 1, margin: '1rem 0', maxWidth: '500px'}} spacing={2}>
                        <Grid item xs={12} md={12} style={{marginBottom: '1rem'}}>
                            <Autocomplete
                                options={role === TEAM_ROLE_TYPE.CLAIMANT ? assignableClaimantArbitrators : assignableRespondentArbitrators}
                                getOptionLabel={value => {
                                    const matchingArb = find(t => value.id ? value.id === t.id : value === t.id, role === TEAM_ROLE_TYPE.CLAIMANT ? assignableClaimantArbitrators : assignableRespondentArbitrators)
                                    if (matchingArb)
                                        return `${matchingArb?.firstName} ${matchingArb.lastName}`
                                }}
                                isOptionEqualToValue={(option, value) => {
                                    return option.id === value
                                }}
                                value={selectedArbitratorId}
                                autoSelect
                                onChange={(e, newValue) => {
                                    if (newValue) {
                                        setSelectedArbitratorId(newValue.id)
                                    }
                                }}
                                renderInput={(params) => <MUITextField {...params} variant="standard" label="Arbitrator"
                                                                       required/>}
                            />
                        </Grid>
                        {/*<Grid>*/}
                        {mapWithIndex((item,idx) => {
                                return (<Grid item xs={12} md={12}>
                                    <TeamAssignment value={selectedTeams[idx]}
                                                    changeHandler={(newTeamId) => onTeamSelected(newTeamId,idx)} />
                                </Grid>)
                            },[...Array(memoAssignmentCount)])
                        }
                    </Grid>
                    <div style={{display: 'flex', gap: '20px', alignItems: 'center'}}>
                        <Button variant='contained' type='sumbit' color='primary'>Save</Button>
                        <NavLink className={'color-dark'} to={`/admin/memoAssignments?role=${role}`}>Cancel</NavLink>
                    </div>
                </form>
            }
        </Container>
    )
}

export default connect(
(state, ownProps) => ({
    router: state.router,
    assignableClaimantArbitrators: state.admin.assignableClaimantArbitrators,
    assignableRespondentArbitrators: state.admin.assignableRespondentArbitrators,
    memoAssignableTeams: state.admin.assignableTeams,
    currentMoot: state.moot.currentMoot,
    ...ownProps
}), {
        getAllMemoAssignments: getAllMemoAssignments,
        getAllArbitrators: getAllArbitrators,
        getMemoAssignableTeams: getMemoAssignableTeams,
        getCurrentMoot: getCurrentMoot,
        saveArbitratorPairing: saveArbitratorPairing
    })(AddAssignment)